import { useMemo } from 'react'

import type { DialogueModalProps } from './types'
import { EMPTY_OBJECT } from '../../utils/object'
import type { ButtonProps } from '../button/types'
import type { CardContentProps } from '../card/types'

const defaultContentProps: CardContentProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: 'lg'
}

const EMPTY_BUTTON_PROPS: ButtonProps & { hide?: boolean } = {}

const defaultHideButton: ButtonProps & { hide?: boolean } = {
  hide: true
}

function useExtractProps(props: DialogueModalProps) {
  return useMemo(() => {
    const {
      variant = 'card-modal',
      display = 'flex',
      flexDirection = 'column',
      modalProps,
      headerActions,
      footer,
      open: _open,
      confirmAction,
      cancelAction,
      labels,
      contentProps: _contentProps = EMPTY_OBJECT,
      checkboxProps,
      checkboxPlacement = 'below',
      closeButtonProps = EMPTY_BUTTON_PROPS,
      cancelButtonProps = !confirmAction
        ? defaultHideButton
        : EMPTY_BUTTON_PROPS,
      confirmButtonProps = !confirmAction
        ? defaultHideButton
        : EMPTY_BUTTON_PROPS,
      autoCloseOnConfirm = true,
      ...rest
    } = props
    const {
      cancel: cancelLabel = 'Cancel',
      ok: okLabel = 'Ok, got it',
      title: titleLabel = 'Title Goes Here',
      descriptions: descriptionsText = 'Description goes here.'
    } = labels ?? {}
    const contentProps = {
      ...defaultContentProps,
      ..._contentProps
    }
    const { hide: hideCloseButton, ...restCloseButtonProps } = closeButtonProps
    const { hide: hideCancelButton, ...restCancelButtonProps } =
      cancelButtonProps
    const { hide: hideConfirmButton, ...restConfirmButtonProps } =
      confirmButtonProps

    return {
      variant,
      display,
      flexDirection,
      modalProps,
      headerActions,
      footer,
      _open,
      confirmAction,
      cancelAction,
      checkboxProps,
      checkboxPlacement,
      rest,
      cancelLabel,
      okLabel,
      titleLabel,
      descriptionsText,
      contentProps,
      hideCloseButton,
      restCloseButtonProps,
      hideCancelButton,
      restCancelButtonProps,
      hideConfirmButton,
      restConfirmButtonProps,
      autoCloseOnConfirm
    }
  }, [props])
}

export default useExtractProps
